import { render, staticRenderFns } from "./people-spider.vue?vue&type=template&id=8ba7240e&scoped=true&"
import script from "./people-spider.vue?vue&type=script&lang=js&"
export * from "./people-spider.vue?vue&type=script&lang=js&"
import style0 from "./people-spider.vue?vue&type=style&index=0&id=8ba7240e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba7240e",
  null
  
)

export default component.exports